import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";
import { RegistruService } from "../registru.service";
import { DataTableDirective } from "angular-datatables";
import { HttpClient } from "@angular/common/http";
import { formatDate } from "@angular/common";
@Component({
    selector: "app-istoric-registru",
    templateUrl: "./istoric-registru.component.html",
    styleUrls: ["./istoric-registru.component.scss"],
})
export class IstoricRegistruComponent implements OnInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    dtOptions: any = {};
    helper = helper;

    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<IstoricRegistruComponent>,
        private registruService: RegistruService,
        private http: HttpClient,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 10,
            order: [[0, "desc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                this.http
                    .get<any>(this.registruService.istoricViewURL + this.data)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.length,
                            recordsFiltered: resp.data.length,
                            data: resp.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "ID",
                    orderable: false,
                    data: "id",
                },
                {
                    title: "Nume Utilizator",
                    orderable: false,
                    data: "user_name",
                },
                {
                    title: "Dată",
                    orderable: false,
                    data: "created_at",
                    render: (data: any, type: any, row: any) => {
                        const formattedData = formatDate(row.created_at, 'yyyy-MM-dd HH:mm:ss', 'en-US')
                        return `
                            <span>${formattedData}</span>
                        `;
                    },
                },
                {
                    title: "Denumire Acțiune",
                    orderable: false,
                    data: "user_action_name",
                },
            ],
        };
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }
}
